// extracted by mini-css-extract-plugin
module.exports = {"root":"detailObjects_root__3jHHe","_read-more-button":"detailObjects__read-more-button__rEJb6"};